import { REPLAY_EVENTS } from './replayAnnotations'

// Shortens every stretch with no events longer than maxGapMs to keptMs, so a student who
// left the page open and came back days later doesn't stretch the timeline into one long
// empty bar. Each skipped stretch gets a timeline marker; `wallTime` keeps the real time for
// displays that show the clock (chat message times). Input must be sorted by timestamp.
export function compressIdleGaps (events, maxGapMs, keptMs = 5000) {
  const out = []
  let shift = 0
  events.forEach((event, i) => {
    const gap = i > 0 ? event.timestamp - events[i - 1].timestamp : 0
    if (gap > maxGapMs) {
      // Just after the last event before the gap, on the compressed timeline.
      out.push({
        type: REPLAY_EVENTS.MARKER,
        timestamp: events[i - 1].timestamp - shift + 1,
        payload: { kind: 'gap', label: `No activity for ${formatGap(gap)} (skipped)` },
      })
      shift += gap - keptMs
    }
    out.push(shift ? { ...event, timestamp: event.timestamp - shift, wallTime: event.wallTime ?? event.timestamp } : event)
  })
  return out
}

function formatGap (ms) {
  const minutes = Math.round(ms / 60000)
  if (minutes < 120) return `${minutes} min`
  const hours = Math.round(minutes / 60)
  return hours < 48 ? `${hours} h` : `${Math.round(hours / 24)} days`
}
